
import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { DataService } from '../data.service';
import { PartOSLangRequest } from '../model/part-oslang-request';
import { AgileSDKService } from '../services/agile-sdk.service';

@Component({
  selector: 'app-os-lang',
  templateUrl: './os-lang.component.html',
  styleUrls: ['./os-lang.component.css'],
  encapsulation: ViewEncapsulation.None 

})
export class OsLangComponent implements OnInit, OnDestroy {
  dropdownList = [];
  selectedItems = [];
  selectedOSValues:string[] = [];
  selectedLangValues:string[] = [];
  osLangRequired:boolean = false;
  initialOSLangRequired:boolean = false;
  isLoading : boolean = true;
  errorLoading : boolean = false
  errorLoadingMsg : string = ''


  myDropDown: string;
  filterOSText : string
  filterLangText : string
  filterOSLangText : string
  addedValues:string[] = [];

  osLangMatrixForm = new FormGroup({
    operatingSystem : new FormControl(''),
    language : new FormControl(''),
    osLangMatrix : new FormControl('')
  }
  );
  
  operatingSystems = [ 
  ]
  Languages = [   
  ]
  PartOsLangSelections = [  
  ]
  @ViewChild('selectOSList', { static: false }) selectOSList: ElementRef;
  @ViewChild('selectLangList', { static: false }) selectLangList: ElementRef;
  @ViewChild('selectOSLangList', { static: false }) selectOSLangList: ElementRef;
  originalOperatingSystems = [];
  originalLanguages: string[];
  originalPartOsLangSelections: string[];
  osLangSubscribe:Subscription;
  constructor(private agileService:AgileSDKService,private dataService:DataService,private router: Router) { }
  ngOnDestroy(): void {
    // throw new Error('Method not implemented.');
    if(this.osLangSubscribe != undefined){
      this.osLangSubscribe.unsubscribe();
    }
  }


  ngOnInit(): void {

    this.loadOSLangValues(this.dataService.urlParams.partNumber);
  }
    onItemSelect(item: any) {
      console.log(item);
    }
    onSelectAll(items: any) {
      console.log(items);
    }

    
  onChangeOfOptionsOS(newGov) {
    console.log(newGov);
  }
  onChangeOfOptionsLang(newGov) {
    console.log(newGov);
  }
  onChangeOfOptionsOSLang(newGov) {
    console.log(newGov);
  }


  filterOSItem(event) {
    console.log('In filter OS')
    if (!event) {
      this.operatingSystems = this.originalOperatingSystems;
    } // when nothing has typed*/   
    if (typeof event === 'string') {
      console.log(event);
      this.operatingSystems = this.originalOperatingSystems.filter(a => a.toLowerCase()
        .includes(event.toLowerCase()));
    }
    console.log(this.operatingSystems.length);
    this.selectOSList.nativeElement.size = this.operatingSystems.length + 1;
  }

  filterLangItem(event) {
    if (!event) {
      this.Languages = this.originalLanguages;
    } // when nothing has typed*/   
    if (typeof event === 'string') {
      console.log(event);
      this.Languages = this.originalLanguages.filter(a => a.toLowerCase()
        .includes(event.toLowerCase()));
    }
    console.log(this.originalLanguages.length);
    this.selectOSList.nativeElement.size = this.operatingSystems.length + 1;
  }

  filterOSLangItem(event) {
    console.log('Here')
    if (!event) {
      this.PartOsLangSelections = this.originalPartOsLangSelections;
    } // when nothing has typed*/   
    if (typeof event === 'string') {
      console.log(event);
      this.PartOsLangSelections = this.originalPartOsLangSelections.filter(a => a.toLowerCase()
        .includes(event.toLowerCase()));
    }
    console.log(this.originalPartOsLangSelections.length);
    this.selectOSLangList.nativeElement.size = this.PartOsLangSelections.length + 1;
  }


  loadOSLangValues(partNumber:string)
  {
    console.log('Getting OS Lang Values for ',partNumber)
    this.osLangSubscribe = this.agileService.getOSLangValues(partNumber).subscribe(
      data => 
      {
        this.isLoading = false;
        console.log('OS Lang Data ' ,data);
        this.operatingSystems = this.originalOperatingSystems = data.availableOsValues;
        this.Languages = this.originalLanguages = data.availableLangValues;
        this.PartOsLangSelections = this.originalPartOsLangSelections = data.partOsLangValues;
        this.osLangRequired = this.initialOSLangRequired = data.hasOsLangMatrix != undefined?(data.hasOsLangMatrix.toLowerCase() == "yes"?true:false):false;
      },
      (error)=>
      {
        console.log('error ',error)
        this.isLoading = false
        this.errorLoading = true
        this.errorLoadingMsg = 'Something went wrong, please try again...'
      }

    )
  }

 

  selectOSLangValues()
  {
    console.log('In select OS Lang Values method ')
    
    this.selectedOSValues = [...this.osLangMatrixForm.get('operatingSystem').value];
    this.selectedLangValues = [...this.osLangMatrixForm.get('language').value]; 

    // if(this.osLangMatrixForm.get('operatingSystem').value.length > 0 )
    if(this.selectedOSValues.length > 0 && this.selectedLangValues.length == 0 )
    {
      console.log('Select atleast one Lang Value')
      window.alert('Select atleast one Lang Value');
    }else if(this.selectedOSValues.length == 0 && this.selectedLangValues.length > 0){
      console.log('Select atleast one OS Value ')
      window.alert('Select atleast one OS Value');
    }else if(this.selectedOSValues.length == 0 && this.selectedLangValues.length == 0){
      console.log('No value selected')
      window.alert('No value selected');
    }else
    {
      console.log('Compute the selected matrix list')

      // this.originalPartOsLangSelections.filter
      // (
      //   (osLang) => 
      //   {
      //     console.log('osLang split ',osLang.split('::::')[0])
      //     if(this.selectedOSValues.includes(osLang.split('::::')[0])){
      //       console.log('OS Exists')
      //     }
      //   }
      // )
      if(this.PartOsLangSelections == undefined){
      this.selectedOSValues =  this.selectedOSValues.map((osValue,indx) => 
      {
        return osValue = osValue+"::::"+this.selectedLangValues.toString();
        // this.selectedOSValues[indx] = osValue;
      })

      this.PartOsLangSelections = this.originalPartOsLangSelections  = this.selectedOSValues;
      this.PartOsLangSelections.forEach((value) => {this.addedValues.push(value)})
     
    }else
    {
      // for each selected OS, if the OS is present in the part selection list, append the Lang values to the row
      // else, add the row with the lang values
      // Iteration - 2 lists - 1 Selected OS and Part OS,
      // if part os split exists in selected os, update the Part OS value and remove the value from the list
      // at the end of the iteration, add the remaining list values to the part os
      this.PartOsLangSelections.map((osLangValue,indx) =>
      {
        let osVal = osLangValue.split("::::")[0];
        let existingLangSet = new Set(osLangValue.split("::::")[1].split(','))
        let inititalLangs = existingLangSet.size
        // console.log('OS Val ',osVal)
        // console.log('Existing Lang ',existingLang);
        // console.log('selected os val index ',this.selectedOSValues.indexOf(osVal))
        if(this.selectedOSValues.indexOf(osVal) >= 0){
          // console.log('removed ',this.PartOsLangSelections.splice(indx,1),' from part os lang');
          // console.log('removed ',this.selectedOSValues.splice(this.selectedOSValues.indexOf(osVal),1),' from selected os values')
          this.selectedOSValues.splice(this.selectedOSValues.indexOf(osVal),1)
          this.selectedLangValues.forEach((langVal) => {
            existingLangSet.add(langVal);
          })
          // console.log('concated value ',osVal+"::::"+this.selectedLangValues.toString())
          this.PartOsLangSelections[indx] = osVal+"::::"+Array.from(existingLangSet).toString()
          
          if(this.addedValues.indexOf(osLangValue) >=0){
            this.addedValues[this.addedValues.indexOf(osLangValue)] = osVal+"::::"+Array.from(existingLangSet).toString()
          }else if(inititalLangs < existingLangSet.size){
            this.addedValues.push(osVal+"::::"+Array.from(existingLangSet).toString());
          }
        }
      })
      console.log('remaining selected os values ',this.selectedOSValues)
      this.selectedOSValues.forEach((osValue) => {
        console.log('os Value ',osValue)
        this.PartOsLangSelections.push(osValue+"::::"+this.selectedLangValues.toString())
        this.addedValues.push(osValue+"::::"+this.selectedLangValues.toString());
      })

      this.originalPartOsLangSelections = this.PartOsLangSelections;
    }
      // this.osLangMatrixForm.get('osLangMatrix').setValue(this.selectedOSValues);

    }
  }

  unSelectOSLangValues()
  {
    console.log('added values ',this.addedValues)
    console.log('In un-select OS Lang Values method ',this.osLangMatrixForm.get('osLangMatrix').value)
    let selectedOSLangMatrixVals:string[] = [];
    selectedOSLangMatrixVals = [...this.osLangMatrixForm.get('osLangMatrix').value];
    selectedOSLangMatrixVals.forEach(value => {
      console.log('value ',value);
      const index = this.PartOsLangSelections.indexOf(value);
      if(index != undefined && index >=0)
      {
        const removedVal = this.PartOsLangSelections.splice(index,1);
        console.log(this.addedValues)
        console.log(removedVal.toString())
        console.log(this.addedValues.indexOf(removedVal.toString()))

        if(this.addedValues.indexOf(removedVal.toString()) >= 0)
        this.addedValues.splice(this.addedValues.indexOf(removedVal.toString()),1)
        // console.log('removed Val ',removedVal,' removed val [0] ',removedVal[0],' Index of ',this.addedValues.indexOf(removedVal[0]))
        // let removedFromAdded = this.addedValues.splice(this.addedValues.indexOf(removedVal[0],1))
        // console.log('removed from added ',removedFromAdded)
      }
    });
  this.originalPartOsLangSelections = this.PartOsLangSelections;
  }
  confirmOSLangValues()
  {
    console.log('OS Values',this.osLangMatrixForm.get('operatingSystem').value);
    console.log('Lang Values',this.osLangMatrixForm.get('language').value);
    // console.log('OS-Lang Matrix Values changed? ',this.valuesUpdated);
    console.log('os lang required ',this.osLangRequired)
    console.log('added values ',this.addedValues)
    // if(this.addedValues.length>0){
    //   console.log('not Same')
    //   let message = 'Do you want to proceed with the OS updates: '+this.addedValues;
    //   if(this.initialOSLangRequired != this.osLangRequired)
    //   {
    //     message = message+" and OS Lang Required to: "+this.osLangRequired
    //   }
      let result = window.confirm('Do you want to proceed with the updates: '+this.addedValues)
      console.log('result ',result)
      if(result)
      {
        // call the post service to update the values
        console.log('sending the part os lang selections ',this.PartOsLangSelections)
        let partOsLangReq:PartOSLangRequest= {userName:this.dataService.getUrlParams().userName,partNumber:this.dataService.urlParams.partNumber,osLangMatrixValues:this.originalPartOsLangSelections,hasOsLangRequired:(this.osLangRequired ?'Yes':'No'),updateOSValues:true};
        this.isLoading = true;
        this.agileService.postOSLangValues(partOsLangReq).subscribe((updated) => {
          this.isLoading = false;
          if(updated)
          {
            window.alert('Successfully updated the OS Lang Values')
            this.router.navigate(['home'], { skipLocationChange: true });
          }else{
            window.alert('Unable to update the OS Lang Values')
          }
        },
        (error) => {
          console.log('Error ',error)
          this.errorLoading = true;
          
        }
        
        );
      }
    // }else{
    //   console.log('Same')
    //   if(this.initialOSLangRequired != this.osLangRequired)
    //   {
    //     let message = 'Do you want to update the value OS Lang Required to ';
    //     if(this.osLangRequired)
    //     {
    //       message = message+"'Yes'";
    //     }else{
    //       message = message+"'No'";
    //     }
    //     let result = window.confirm(message)
    //     if(result)
    //     {
    //       // call the API to update the values
    //       let partOsLangReq:PartOSLangRequest= {partNumber:this.partNumber,osLangMatrixValues:[],hasOsLangRequired:(this.osLangRequired ?'Yes':'No'),updateOSValues:false};
    //       this.agileService.postOSLangValues(partOsLangReq).subscribe(
    //         (updated) => {
    //           if(updated)
    //           {
    //             window.alert('Successfully updated the OS Lang Values')
    //           }else{
    //             window.alert('Unable to update the OS Lang Values')
    //           }
    //         }
    //       );
    //     }
    //   }else{
    //   window.alert('No changes to the existing values ')}
    // }

  
    
  }
 onCancel(){
  this.router.navigate(['home'], { skipLocationChange: true })
 }
}
export function atleastOneLangValidation() {
    
}